import { 
  collection, doc, getDocs, addDoc, updateDoc, deleteDoc, query, where, serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

export const getAllNotes = async () => {
  const snap = await getDocs(collection(db, 'notes'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getNotesByChapter = async (chapterId) => {
  const q = query(collection(db, 'notes'), where('chapterId', '==', chapterId));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const createNote = async (data) => {
  const payload = {
    chapterId: data.chapterId,
    content: data.content || '',
    seoDescription: data.seoDescription || '',
    seoKeywords: Array.isArray(data.seoKeywords) ? data.seoKeywords : (data.seoKeywords ? String(data.seoKeywords).split(',').map(s => s.trim()).filter(Boolean) : []),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  const ref = await addDoc(collection(db, 'notes'), payload);
  return ref.id;
};

export const updateNote = async (id, data) => {
  const payload = {
    ...data,
    ...(data.seoKeywords !== undefined ? { seoKeywords: Array.isArray(data.seoKeywords) ? data.seoKeywords : String(data.seoKeywords).split(',').map(s => s.trim()).filter(Boolean) } : {}),
    updatedAt: serverTimestamp()
  };
  await updateDoc(doc(db, 'notes', id), payload);
};

export const deleteNote = async (id) => {
  await deleteDoc(doc(db, 'notes', id));
};


